import { EMPLOYEE_ROLES, PERMISSIONS } from './enums';
import * as Constants from './constants';

const BOOKING_PERMISSIONS = [
  PERMISSIONS.CHECK_IN_DANCERS,
  PERMISSIONS.SEND_INVITES,
  PERMISSIONS.MANAGE_CONVERSATIONS,
  PERMISSIONS.MANAGE_REQUESTS,
  PERMISSIONS.MANAGE_GROUPS,
];

const MANAGER_PERMISSIONS = [
  PERMISSIONS.CHECK_IN_DANCERS,
  PERMISSIONS.SEND_INVITES,
  PERMISSIONS.MANAGE_CONVERSATIONS,
  PERMISSIONS.EDIT_CLUB,
  PERMISSIONS.MANAGE_GROUPS,
  PERMISSIONS.MANAGE_REQUESTS,
  PERMISSIONS.MANAGE_BOOKINGS,
  PERMISSIONS.BLOCK_DANCERS,
  PERMISSIONS.MANAGE_EMPLOYEES,
  PERMISSIONS.SEARCH_DANCERS,
];

const ALL_PERMISSIONS = [
  PERMISSIONS.CHECK_IN_DANCERS,
  PERMISSIONS.SEND_INVITES,
  PERMISSIONS.MANAGE_CONVERSATIONS,
  PERMISSIONS.EDIT_CLUB,
  PERMISSIONS.MANAGE_GROUPS,
  PERMISSIONS.MANAGE_REQUESTS,
  PERMISSIONS.MANAGE_BOOKINGS,
  PERMISSIONS.BLOCK_DANCERS,
  PERMISSIONS.MANAGE_EMPLOYEES,
  PERMISSIONS.SEARCH_DANCERS,
  PERMISSIONS.MANAGE_REG_CODES,
];

const BASIC_CLUB_PERMISSIONS = [
  PERMISSIONS.CHECK_IN_DANCERS,
  PERMISSIONS.MANAGE_CONVERSATIONS,
  PERMISSIONS.MANAGE_REQUESTS,
  PERMISSIONS.MANAGE_BOOKINGS,
];

export const getRolePermissionOptions = (role, businessTier) => {
  if (!role) return [];

  if(businessTier === 'UNVERIFIED') return [];

  if(businessTier === 'BASIC') return BASIC_CLUB_PERMISSIONS;

  else if (role === EMPLOYEE_ROLES.BOOKING_AGENT) return BOOKING_PERMISSIONS;
  else if (role === EMPLOYEE_ROLES.MANAGER) return MANAGER_PERMISSIONS;
  else return ALL_PERMISSIONS;
};

export const getRoleOptions = (businessTier) => {
  let allowedRoles;

  switch (businessTier) {
    case 'UNVERIFIED':
      allowedRoles = Constants.UNVERIFIED_CLUBS_EMPLOYEE_ROLE_OPTIONS;
      break;
    case 'BASIC':
      allowedRoles = Constants.BASIC_CLUBS_EMPLOYEE_ROLE_OPTIONS;
      break;
    case 'PRO':
      allowedRoles = Constants.EMPLOYEE_ROLE_OPTIONS;
      break;
    default:
      allowedRoles = Constants.EMPLOYEE_ROLE_OPTIONS;
      break;
  }

  return allowedRoles;
};
